import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Prevents image downloading/saving on all non-admin pages.
 * Blocks: right-click on images, drag, long-press save.
 * Does NOT affect admin routes (/admin/*).
 */
export default function ImageProtection() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  useEffect(() => {
    if (isAdmin) return;

    // Prevent right-click context menu on images
    const handleContextMenu = (e) => {
      if (e.target.tagName === "IMG" || e.target.closest("img")) {
        e.preventDefault();
      }
    };

    // Prevent drag on images
    const handleDragStart = (e) => {
      if (e.target.tagName === "IMG") {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("dragstart", handleDragStart);

    // Add CSS to prevent image selection and saving
    const style = document.createElement("style");
    style.id = "mahra-image-protection";
    style.textContent = `
      img:not([data-admin]) {
        -webkit-user-select: none;
        user-select: none;
        -webkit-touch-callout: none;
        -webkit-user-drag: none;
        pointer-events: auto;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("dragstart", handleDragStart);
      const existing = document.getElementById("mahra-image-protection");
      if (existing) existing.remove();
    };
  }, [isAdmin]);

  return null;
}
